/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateDocumentSchemaCommand } from '../../models/create-document-schema-command';
import { DocumentSchema } from '../../models/document-schema';

export interface ApiDocumentSchemasSchemaPost$Plain$Params {
      body: CreateDocumentSchemaCommand
}

export function apiDocumentSchemasSchemaPost$Plain(http: HttpClient, rootUrl: string, params: ApiDocumentSchemasSchemaPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSchema>> {
  const rb = new RequestBuilder(rootUrl, apiDocumentSchemasSchemaPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentSchema>;
    })
  );
}

apiDocumentSchemasSchemaPost$Plain.PATH = '/api/DocumentSchemas/schema';
